module.exports = __webpack_public_path__ + "img/japones_1.b819f7ff.png";